  function startCountdown() {
    const countdownElement = document.getElementById('countdown');
    const title1Element = document.getElementById('info-title-1');
    const title2Element = document.getElementById('info-title-2');
    const title3Element = document.getElementById('info-title-3');
    const text1Element = document.getElementById('info-text-1');
    const text2Element = document.getElementById('info-text-2');

    function updateVisibility() {
      const currentTime = new Date();
      const currentDay = currentTime.getDay(); // 0 = Sonntag, 6 = Samstag
      const currentHour = currentTime.getHours();

      // Überprüfe die Zeitfenster und zeige die entsprechenden Elemente an/aus
      if ((currentHour >= 0 && currentHour < 13) && (currentDay >= 1 && currentDay <= 5)) {
        title1Element.style.display = 'block';
        title2Element.style.display = 'none';
        title3Element.style.display = 'none';
        text1Element.style.display = 'block';
        text2Element.style.display = 'none';
      } else if ((currentHour >= 13 || currentHour < 0) && (currentDay >= 1 && currentDay <= 5)) {
        title1Element.style.display = 'none';
        title2Element.style.display = 'block';
        title3Element.style.display = 'none';
        text1Element.style.display = 'block';
        text2Element.style.display = 'none';
      } else if ((currentDay === 5 && currentHour >= 0) || (currentDay === 6) || (currentDay === 0 && currentHour < 24)) {
        title1Element.style.display = 'none';
        title2Element.style.display = 'none';
        title3Element.style.display = 'block';
        text1Element.style.display = 'none';
        text2Element.style.display = 'block';
      }
    }

    function updateCountdown() {
      const targetTime = new Date();
      targetTime.setHours(13, 0, 0, 0); // Setze Stunden und Minuten auf 13:00 Uhr

      const currentTime = new Date().getTime();
      const distance = targetTime - currentTime;

      if (distance <= 0) {
        updateVisibility();
      } else {
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

        countdownElement.innerText = hours + 'h ' + minutes + 'm';
      }
    }

    updateVisibility();
    setInterval(updateVisibility, 60 * 60 * 1000); // Überprüfe die Sichtbarkeit alle Stunde
    setInterval(updateCountdown, 1000);
  }

  window.onload = startCountdown;